import { render } from "./Wall.vue?vue&type=template&id=3c465634"
import script from "./Wall.vue?vue&type=script&lang=js"
export * from "./Wall.vue?vue&type=script&lang=js"
script.render = render

export default script